const SUPPORTED_LOCALE_REGEXP = /^([a-zA-Z]{2})[-_]([a-zA-Z]{2})$/;

export const formatLocale = (locale: string): string =>
  locale == null
    ? locale
    : locale.replace(
        SUPPORTED_LOCALE_REGEXP,
        (_match: string, p1: string, p2: string) => `${p1.toLowerCase()}_${p2.toUpperCase()}`,
      );
